import HttpRepository from '@/services/HttpRepository'
import Repository from '@/services/Repository'
import {
  ChooseSlotPayload,
  ClientPage,
  Delivery,
  GetSlotsPayload,
  GetSlotsResponse,
  GetUnavailableDatesPayload,
  GetUnavailableDatesResponse,
  MultiTrackingGlobalOrder,
  ScorePayload,
} from '@/types'

export interface IDeliveryRepository {
  get: (
    accessToken: string,
    params: Record<string, any>,
  ) => Promise<{
    delivery: Delivery
    pages: ClientPage[]
    deliveries?: Delivery[]
    globalOrder?: MultiTrackingGlobalOrder | null
    languages?: string[]
    minDeliveryPromiseDate: string | null
  }>
  createScore: (accessToken: string, score: ScorePayload) => Promise<void>
  chooseSlot: (
    accessToken: string,
    payload: ChooseSlotPayload,
  ) => Promise<{ status: string; message?: string }>
  getSlots: (accessToken: string, params: GetSlotsPayload) => Promise<{ data: GetSlotsResponse }>
  getUnavailableDates: (
    accessToken: string,
    params: GetUnavailableDatesPayload,
  ) => Promise<{ data: GetUnavailableDatesResponse }>
}

export default class DeliveryRepository extends HttpRepository {
  async createScore(accessToken: string, payload: ScorePayload): Promise<void> {
    await Repository.post(`${this.endpoint}/${accessToken}/scores`, payload)
  }
  async getSlots(
    accessToken: string,
    params: GetSlotsPayload,
  ): Promise<{ data: GetSlotsResponse }> {
    return Repository.get(`${this.endpoint}/${accessToken}/slots`, { params })
  }

  async chooseSlot(
    accessToken: string,
    payload: ChooseSlotPayload,
  ): Promise<{ status: string; message?: string }> {
    return Repository.post(`${this.endpoint}/${accessToken}/choose-slot`, payload)
  }

  async getUnavailableDates(
    accessToken: string,
    params: GetUnavailableDatesPayload,
  ): Promise<{ data: GetUnavailableDatesResponse }> {
    return Repository.get(`${this.endpoint}/${accessToken}/get-unavailable-dates`, { params })
  }
}
